import { createReducer, on } from "@ngrx/store";
import { IOrganization, IOrganizationType } from "../model/organization";
import { IQueryResult } from "@pmis3/data-access";
import { LoadOrganizations, LoadOrganizationsSuccess, LoadOrganizationsFail, LoadOrganizationTypes } from "../action/organization.action";

export enum OrganizationStateStatus {
  LOADING = "loading organizations",
  FAILED = "load organizations failed",
  PENDING = "pending load for organizations",
  SUCCESS = "load organizations success",
  LOAD_ORGANIZATION_TYPES = "load organization types"
}
export interface OrganizationState {
  organizations?: IOrganization[];
  error?: string;
  status: OrganizationStateStatus;
  organizationTypes: IOrganizationType[]
}

export const initialOrganizationState: OrganizationState = {
    organizations: [],
    status: OrganizationStateStatus.PENDING,
    organizationTypes: []
}

export const organizationReducer = createReducer(
  initialOrganizationState,
    on(LoadOrganizations, (state) => ({...state, status: OrganizationStateStatus.LOADING})),
    on(LoadOrganizationsSuccess, (state, {result: organizations }) => ({...state, organizations: organizations, organizationTypes: state.organizationTypes, status: OrganizationStateStatus.SUCCESS})),
    on(LoadOrganizationsFail, (state, { error }) => ({...state, error, status: OrganizationStateStatus.FAILED})),
    on(LoadOrganizationTypes, (state, { organizationTypes: organizationTypes }) => ({
      ...state,
      organizations: state.organizations,
      organizationTypes: organizationTypes,
      status: OrganizationStateStatus.LOAD_ORGANIZATION_TYPES
    }))
)